export const Location = () => {
  return (
    <p className="location">
      Based in: <b>Napa, CA</b>{" "}
    </p>
  );
};
